import * as React from 'react'
import { useIdleTimer } from 'react-idle-timer'
import LimitConnectionTime from './LimitConnectionTime'

const SesstionTimeout = ({onLogout, 
  activeTimeOutTime, 
  activeTimeOutCountdown,
  activeTimeOutText,
  limitConnectionTime, 
  limitConnectionCountdown,
  limitConnectionText
}) => {

  //   const [state, setState] = React.useState('Active')
  //   const [remaining, setRemaining] = React.useState(0)
  

  // const onIdle = () => {
  //   console.log("Idle", activeTimeOutTime);
  //   if(activeTimeOutTime > 0)
  //   {
  //       setState('Idle');
        
  //       if(typeof onLogout === 'function')
  //       {
  //           onLogout();
  //       }
  //       console.log("logout complete");
  //   }
  // }
  
  // const onActive = () => {
  //   if (state === "Active"){
  //       setState('Active')
  //       console.log("Active");
  //   }
  
  //   console.log(remaining);
  // }
  
  // const onAction = () => {
  // }
  
  // const { getRemainingTime } = useIdleTimer({
  //   onIdle,
  //   onActive,
  //   onAction,
  //   timeout: 1000 * activeTimeOutTime,
  //   throttle: 500
  // })
  
  
  // React.useEffect(() => {
  //       const interval = setInterval(() => {
  //           setRemaining(Math.ceil(getRemainingTime() / 1000))
  //         }, 500)
      
  //         return () => {
  //           clearInterval(interval)
  //         }
  // })

    return (<> { limitConnectionTime && <LimitConnectionTime logout={onLogout} limitConnectionTime={limitConnectionTime} limitConnectionTimeCountdown={limitConnectionCountdown} timeOutText={limitConnectionText}></LimitConnectionTime>}
    { activeTimeOutTime && <LimitConnectionTime logout={onLogout} limitConnectionTime={activeTimeOutTime} limitConnectionTimeCountdown={activeTimeOutCountdown} timeOutText={activeTimeOutText}></LimitConnectionTime>}</>)
}

export default SesstionTimeout;